import React, { FC } from 'react';

import './ToggleButton.css';

export type ToggleButtonProps = {
  label: string | React.ReactNode;
  checked: boolean;
  id: string;
  onChange: (checked: boolean) => void;
};

export const ToggleButton: FC<ToggleButtonProps> = (props) => {
  return (
    <div className="switch-button-container">
      <div>
        <input
          type="checkbox"
          checked={props.checked}
          id={props.id}
          data-cy={`optinToggle${props.id}`}
          className="switch-button-input"
          onChange={(event) => props.onChange(event.target.checked)}
        />
        <label htmlFor={props.id} className="switch-button-label" />
      </div>
      <label htmlFor={props.id} style={{ marginLeft: 10 }} data-cy={`optinText${props.id}`}>
        {typeof props.label === 'string' ? (
          <span dangerouslySetInnerHTML={{ __html: props.label }} />
        ) : (
          props.label
        )}
      </label>
    </div>
  );
};
